import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { useSelector } from 'react-redux'

import ReservationForClientForm from '@/components/Reservations/ReservationForClientForm/ReservationForClientForm'
import { selectActiveBuilding } from '@/reducers/buildingSelectorReducer'
import { selectClients } from '@/reducers/clientsReducer'

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY)

// Note: tells Stripe's embedded card-field iframe to load Montserrat, matching the app's
// own font instead of falling back to a generic sans-serif.
const STRIPE_OPTIONS = {
  fonts: [
    {
      cssSrc: 'https://fonts.googleapis.com/css?family=Montserrat:400,500,700&amp;subset=latin-ext',
    },
  ],
}

const mapClientToUser = ({ id, apartment: unit, user, phone, creditCardId }: any) => ({
  creditCardId,
  email: user.email,
  label: `${user.firstName} ${user.lastName}`,
  phone,
  unit,
  userId: user.id,
  value: id,
})

interface AddReservationModalProps {
  onClose: VoidFunction
}

export const AddReservationModal = ({ onClose }: AddReservationModalProps) => {
  const activeBuilding = useSelector(selectActiveBuilding)
  const clients = useSelector(selectClients)

  return (
    <Elements options={STRIPE_OPTIONS} stripe={stripePromise}>
      <ReservationForClientForm
        handleCancel={onClose}
        residents={clients.map(mapClientToUser)}
        buildingData={activeBuilding}
      />
    </Elements>
  )
}
